export default __webpack_public_path__ + "locales/az/WebPlugins.json?hash=486267c2bd9f38d952bc788697c1f574";